// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_2Vz","cls2":"SingularMentionCitationModal-cls2_yYj SingularMentionCitationModal-cls1_2Vz"};